<template>
  <div class="loginmg">
    <div class="containerNa">
      <div class="imglg">
        <img
          src="../assets/images/zhiyelogoendeee.svg"
          alt=""
          class="imglogo"
          @click="toindextoindex()"
        />
        <div class="city" @click="toChooseCity">
          <i class="el-icon-location-information"></i>
          <span>{{ currentCity }}</span>
        </div>
      </div>

      <ul>
        <li>
          <span v-if="showloAndre" @click="toLoginOrRegist" class="pushhouse"
            >登录/注册</span
          >

          <img
            v-bind:src="avatarimg"
            v-if="showUserInfo"
            alt=""
            class="userimg"
            @click="topersonalPage"
          />
          <h5 class="usernameshow" v-if="showUserInfo" @click="topersonalPage">
            个人中心
          </h5>

          <h5
            class="usernameshow"
            v-if="showUserInfo"
            @click="quitpersonalPage"
            style="margin-left: 37px"
          >
            退出
          </h5>
        </li>
        <li @click="toreleaseHouse">
          <span class="pushhouse">发布房源</span>
        </li>
        <li @click="toChat">
          <span class="houselist1">消息中心</span>
          <span class="noReadCount" v-if="noReadCount > 0">{{
            noReadCount
          }}</span>
        </li>
        <li @click="toHouseList">
          <span class="houselist1">房源列表</span>
        </li>
        <li @click="toIndex">
          <span class="houselist2">首页</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { getLoaction } from "../location.js";
import https from "../http.js";
import qs from "qs";
export default {
  data() {
    return {
      userId: "",
      showUserInfo: false,
      showloAndre: true,
      username: "",
      avatarimg: "",
      currentCity: "",
      noReadCount: 0,
    };
  },

  async mounted() {
    this.initWebSocket();
    window.addEventListener("onmessageWS", this.onSocketMessage);
  },

  created: function() {
    this.$bus.$on("changNoRead", (msg) => {
      this.noReadCount = parseInt(this.noReadCount - msg);
    });
    getLoaction.getLocationAddress().then((locationData) => {
      this.currentCity = locationData.ad_info.city;
    });

    //  var tokenshoww = sessionStorage.getItem('token');
    var tokenshoww = this.$cookies.get("token");
    //  var usernamed = sessionStorage.getItem('username')
    // var usernamed = this.$cookies.get("username");
    var usernamed = this.tool.getCookie("username");
    //  var avatarimgd = sessionStorage.getItem('avatarimg');
    var avatarimgd = this.$cookies.get("avatarimg");
    // var useridd = sessionStorage.getItem("userid");
    var useridd = this.$cookies.get("userid");
    if (useridd !== null) {
      this.userId = useridd;
      this.showUserInfo = true;
      this.showloAndre = false;
    }

    if (usernamed !== null) {
      this.username = usernamed;
      this.avatarimg =
        "http://www.zhiyefangdong.com/uploads/avatarimg/" + avatarimgd;
    }

    this.getAllNoReadCount();
  },

  methods: {
    async initWebSocket() {
      this.$websocket.connectSocket();
    },

    //监听socket消息
    onSocketMessage(res) {
      var onMessageData = res.detail.data;
      if (onMessageData.type == "text" || onMessageData.type == "say_img") {
        this.noReadCount = parseInt(this.noReadCount) + 1;
      }
    },
    getAllNoReadCount() {
      https
        .fetchPost(
          "/chat/get-all-no-read-count",
          qs.stringify({ id: this.userId })
        )
        .then((res) => {
          this.noReadCount = res.data.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    toChooseCity() {
      this.$router.push({ path: "/ChooseCity" });
    },

    toHouseList() {
      this.$router.push({ path: "/HouseList" });
    },

    toChat() {
      this.$router.push({ path: "/Chat" });
    },

    toindextoindex() {
      this.$router.push({ path: "/index" });
    },

    toreleaseHouse() {
      this.$router.push({ path: "/ReleaseHouse" });
    },

    toLoginOrRegist() {
      this.$router.push({ path: "/Login" });
    },

    toIndex() {
      this.$router.push({ path: "/index" });
    },

    topersonalPage() {
      this.$router.push({ path: "/PersonalCenter" });
    },

    quitpersonalPage() {
      // sessionStorage.clear();
      console.log("pppppppppp");
      var cooki = this.$cookies.keys();
      this.$websocket.close();
      cooki.forEach((element) => {
        // console.log(element, "999");
        // this.$cookies.remove(element);
        // console.log(element);
        this.$cookies.set(element, "", -1, "/dist");
      });
      // for(var i=0;i<this.$cookies.ke{

      // }
      // this.$router.push({ path: "/index" }); //测试
      location.reload();
    },
  },
};
</script>

<style scoped>
.userimg {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  margin-top: 9px;
  float: left;
}

.usernameshow {
  float: left;
  color: #fff;
  margin-left: 10px;
  margin-top: 20px;
}

.imglg {
  display: flex;
  align-items: center;
}

.imglg .city {
  width: fit-content;
  color: #fff;
  display: flex;
  align-items: center;
  white-space: nowrap;
  font-weight: 600;
  border: 1px solid;
  padding: 4px 10px;
  border-radius: 20px;
  cursor: pointer;
}

.imglg .city .el-icon-location-information {
  font-size: 18px;
}

.imglg .city span {
  font-size: 16px;
}

.imglogo {
  width: 123px;
  height: 80px;
  margin-top: -9px;
  margin-left: 68px;
  cursor: pointer;
}

.containerNa {
  display: flex;
  width: 100%;
  height: 60px;
  /* background: linear-gradient(to right, #ffe259, #ffa751); */
  /* background: linear-gradient(to right, #f7ae58, #ffa751); */
  /* background: linear-gradient(to right, #97c74e, #2ab9a5); */
  background: #000;

  z-index: 999;
  opacity: 1;
}

.containerNa ul {
  /* 清除ul标签的默认样式 */
  width: 80%;
  list-style-type: none;
  margin: 0;
  padding: 0;
  overflow: hidden;
}
.containerNa li {
  float: right; /* 使li内容横向浮动，即横向排列  */
  margin-right: 30px; /* 两个li之间的距离*/
  cursor: pointer;
  position: relative;
}

.containerNa li a {
  /* 设置链接内容显示的格式*/
  display: block; /* 把链接显示为块元素可使整个链接区域可点击 */
  color: white;
  text-align: center;
  padding: 18px 16px;
  text-decoration: none; /* 去除下划线 */
}

.pushhouse {
  display: block;
  color: white;
  text-align: center;
  padding: 8px 16px;
  border: 1px solid;
  margin-top: 10px;
}

.houselist1 {
  display: block;
  color: white;
  text-align: center;
  padding: 8px 16px;

  margin-top: 10px;
}

.noReadCount {
  position: absolute;
  height: 18px;
  color: #fff;
  background: red;
  border-radius: 10px;
  line-height: 18px;
  right: 0px;
  top: 15px;
  font-weight: 500;
  font-size: 14px;
  padding: 0px 5px;
}

.houselist1:hover {
  display: block;
  color: white;
  text-align: center;
  padding: 8px 16px;
  background: #0e86e2;
  margin-top: 10px;
}

.houselist2 {
  display: block;
  color: white;
  text-align: center;
  padding: 8px 16px;

  margin-top: 10px;
}

.houselist2:hover {
  display: block;
  color: white;
  text-align: center;
  padding: 8px 16px;
  background: #0e86e2;
  margin-top: 10px;
}

.houselist3 {
  display: block;
  color: white;
  text-align: center;
  padding: 8px 16px;

  margin-top: 10px;
}
</style>
